export enum ApiUserRole  {

     
     AdminPlateforme		= "AdminPlateforme",     //1
     AdminPiscine			= "AdminPiscine",        //2
     Famille		          = "Famille",             //4
     Client		          = "Client",              //8
     MNS			          = "MNS",                 //16
     ProprietairePiscine		= "ProprietairePiscine", //32
} 